import { render, staticRenderFns } from "./FakeSearch.vue?vue&type=template&id=ebc6f830&scoped=true"
import script from "./FakeSearch.vue?vue&type=script&lang=ts"
export * from "./FakeSearch.vue?vue&type=script&lang=ts"
import style0 from "./FakeSearch.vue?vue&type=style&index=0&id=ebc6f830&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc6f830",
  null
  
)

export default component.exports